import type { ReactNode } from 'react';

import FOSSALogoWithCatWhite from '../../generic/FOSSAInlineSVG/FOSSALogoWithCatWhite';
import Link from '../../generic/Link/Link';

import MarketingBlurb from './MarketingBlurb';
import MarketingTrustedBy from './MarketingTrustedBy';

import styles from './AuthLayoutTwoCol.module.less';

export type AuthLayoutTwoColProps = {
  children: ReactNode;
};

/**
 * Two-column shell for the register page: the brand blurb and "trusted by" logos beside the auth card, on the
 * brand-black background. The marketing column collapses on narrow screens, leaving just the card.
 */
const AuthLayoutTwoCol = ({ children }: AuthLayoutTwoColProps) => (
  <div className={styles.page}>
    <div className={styles.logo}>
      <Link to="https://fossa.com/" openInNewTab>
        <FOSSALogoWithCatWhite width={150} />
      </Link>
    </div>
    <div className={styles.columns}>
      {/* The auth card comes first in the DOM (assistive tech reaches the form before the marketing copy,
          matching the narrow-viewport visual order); on wide screens CSS order places marketing on the left. */}
      <div className={styles.content}>{children}</div>
      <section className={styles.marketing}>
        <MarketingBlurb />
        <MarketingTrustedBy />
      </section>
    </div>
  </div>
);

export default AuthLayoutTwoCol;
